// @ts-check
// Página Conversas (/conversations e /conversations/:threadId) e aba Conversas do card e da pessoa. Com o módulo
// Atendimento ligado (3.0.0), a página mostra só as conversas de captação; as de atendimento ficam na Caixa.
import { html } from 'htm/preact';
import { useEffect, useState } from 'preact/hooks';
import { navigate, searchParamsState } from '../../app/router.js';
import { readDrilldownParam } from '../../lib/drilldown-links.js';
import { DRILLDOWN_URL_PARAM } from '../../../../shared/dashboards/drilldown-recipe.js';
import { drilldownRefreshState } from '../views/drilldown-chip.js';
import { PageCard, PageHeader } from '../page/page-card.js';
import { Button } from '../../ui/button.js';
import { openNewConversationPanel } from '../side-panel/side-panel-state.js';
import { ConversationInbox } from './conversation-inbox.js';
import { isTenantModuleEnabled } from '../../data/metadata-store.js';
import { t } from '../../i18n/index.js';

/**
 * @param {{ threadId?: string | null }} props
 */
export function ConversationsPage({ threadId = null }) {
  const [refreshKey, setRefreshKey] = useState(0);
  // caixa aberta por um clique num gráfico de conversas: o recorte fica na URL ao abrir cada conversa
  const drilldown = readDrilldownParam(searchParamsState.value);
  const drilldownSearch = drilldown ? `?${new URLSearchParams({ [DRILLDOWN_URL_PARAM]: drilldown }).toString()}` : '';
  useEffect(() => {
    document.title = t('conversations.title');
  }, []);
  return html`<${PageCard}
    className="conversations-page-card"
    header=${html`<${PageHeader}
      icon="IconMessages"
      title=${t('conversations.title')}
      actions=${html`<${Button}
        title=${t('conversations.newConversation')}
        icon="IconPlus"
        variant="secondary"
        size="small"
        onClick=${() =>
          openNewConversationPanel({
            onCreated: (thread) => {
              setRefreshKey((value) => value + 1);
              navigate(`/conversations/${thread.id}`);
            },
          })}
      />`}
    />`}
  >
    <${ConversationInbox}
      selectedThreadId=${threadId}
      refreshKey=${refreshKey + drilldownRefreshState.value}
      drilldown=${drilldown}
      purpose=${isTenantModuleEnabled('SERVICE_DESK') ? 'CAPTURE' : null}
      onClearDrilldown=${() => navigate(threadId ? `/conversations/${threadId}` : '/conversations', { replace: true })}
      onSelectThread=${(selectedId) => navigate(`${selectedId ? `/conversations/${selectedId}` : '/conversations'}${drilldownSearch}`)}
    />
  <//>`;
}

/**
 * Aba do registro: mesma caixa filtrada pela pessoa ou pelo card, com seleção local.
 * @param {{ objectNameSingular: string, record: any }} props
 */
export function RecordConversationsTab({ objectNameSingular, record }) {
  const [selectedThreadId, setSelectedThreadId] = useState(/** @type {string | null} */ (null));
  const [refreshKey, setRefreshKey] = useState(0);
  const isPerson = objectNameSingular === 'person';
  const email = isPerson ? record?.emails?.primaryEmail ?? '' : '';
  const phone = isPerson && record?.phones?.primaryPhoneNumber ? `${record.phones.primaryPhoneCallingCode ?? '+55'}${record.phones.primaryPhoneNumber}` : '';
  return html`<div class="record-conversations">
    <div class="record-conversations-toolbar">
      <${Button}
        title=${t('conversations.newConversation')}
        icon="IconPlus"
        variant="secondary"
        size="small"
        onClick=${() =>
          openNewConversationPanel({
            defaultChannelType: email || !phone ? 'EMAIL' : 'WHATSAPP',
            defaultTo: { EMAIL: email, WHATSAPP: phone },
            personId: isPerson ? record?.id : objectNameSingular === 'enrollmentOpportunity' ? record?.pointOfContactId ?? null : null,
            onCreated: (thread) => {
              setRefreshKey((value) => value + 1);
              setSelectedThreadId(thread.id);
            },
          })}
      />
    </div>
    <${ConversationInbox}
      isCompact=${true}
      personId=${isPerson ? record?.id : null}
      enrollmentOpportunityId=${objectNameSingular === 'enrollmentOpportunity' ? record?.id : null}
      householdId=${objectNameSingular === 'household' ? record?.id : null}
      selectedThreadId=${selectedThreadId}
      refreshKey=${refreshKey}
      onSelectThread=${setSelectedThreadId}
      emptyTitle=${t('conversations.tabEmptyTitle')}
      emptySubtitle=${t('conversations.tabEmptySubtitle')}
    />
  </div>`;
}
